import React from 'react'
import { Modal } from 'antd'
import { Initial } from 'react-initial'
import { renderToStaticMarkup } from 'react-dom/server'
import i18n from 'i18n'
import classNames from 'classnames'

import { store as reduxStore } from 'index'

import store from 'store'
import conf from 'conf'

// import 'react-perfect-scrollbar-z/build/styles.css'
// import PerfectScrollbar from 'react-perfect-scrollbar-z'

import {
  getSearchParamProps,
  setSearchParams,
  encodeNSearch,
  encodeSortMap,
  checkPageReplace,
  timeFormat as timeFormatOrigin,
} from 'utils'

import parse from 'html-react-parser'
import syncAniGIF from 'assets/images/sync-ani.gif'

import sortAscendSVG from 'assets/images/sort-ascend.svg'
import sortDescendSVG from 'assets/images/sort-descend.svg'
import xCircleBlue22SVG from 'assets/images/x-circle-blue-22.svg'
import xCircleRed22SVG from 'assets/images/x-circle-red-22.svg'
import exclamationCircleRed22SVG from 'assets/images/exclamation-circle-red-22.svg'

import styles from './style.module.scss'

// window.moment = moment

// const getUTCTime = (time) => {
//   let utcTime = time
//   if (time != null && time.length > 0 && time.indexOf('Z') === -1) {
//     utcTime = `${time}Z`
//   }
//   return utcTime
// }

export function getHighlightedText(str, highlightText) {
  const txt = str != null ? str : ''
  if (highlightText == null || highlightText.length === 0) {
    return str
  }

  const lowertxt = txt.toLowerCase()
  const lowerHtxt = highlightText.toLowerCase()
  const pos = lowertxt.indexOf(lowerHtxt)

  if (pos >= 0) {
    const preText = txt.substring(0, pos)
    const hText = txt.substring(pos, pos + highlightText.length)
    const nextText = txt.substring(pos + highlightText.length)

    return (
      <span>
        {preText}
        <span className="highlight">{hText}</span>
        {nextText}
      </span>
    )
  }

  return <span>{str}</span>
}

export const colors = [
  '#A9624A',
  '#D06B64',
  '#F83A22',
  '#FA573C',
  '#FF7537',
  '#FF950F',
  '#00BB65',
  '#008247',
  '#43A608',
  '#6BBC00',
  '#FFA600',
  '#FFBC0A',
  '#67AC8F',
  '#61BCC4',
  '#7AA4C8',
  '#4986E7',
  '#6D6FDE',
  '#8562D6',
  '#8D8D8D',
  '#AB8E92',
  '#A7767D',
  '#F46594',
  '#F46594',
  '#7446B7',
]

export function getInitialAvatar(name, email) {
  if (name == null && email == null) {
    return null
  }

  const avatarProps = {
    // charCount: 2,
    charCount: 1,
  }

  let tmp = []
  if (name != null) {
    tmp = name.split(/[\s\r\n,.]+/gm)
  } else {
    const pos = email.indexOf('@')
    tmp = email.substring(0, pos - 1).split(/[\s\r\n,.]+/gm)
    // const eText = email.substring(pos);
  }

  let str = ''
  tmp.forEach((txt) => {
    if (/^(\p{L}|\d)/gu.test(txt) === true) {
      str += txt.charAt(0)
    }
  })

  str = str.toUpperCase()

  avatarProps.name = str

  const seed = 0
  avatarProps.color = colors[Math.floor((str.charCodeAt(0) + seed) % colors.length)]

  return <Initial {...avatarProps} />
}

function unicodeCharAt(str, index) {
  const first = str.charCodeAt(index)
  let second

  if (first >= 0xd800 && first <= 0xdbff && str.length > index + 1) {
    second = str.charCodeAt(index + 1)

    if (second >= 0xdc00 && second <= 0xdfff) {
      return str.substring(index, index + 2)
    }
  }

  return str[index]
}

function unicodeSlice(str, start, end, words) {
  let accumulator = ''
  let character
  let stringIndex = 0
  let unicodeIndex = 0
  let nextSpace = -1
  const { length } = str

  // Remove any leading/trailing spaces
  str = str.trim()

  while (stringIndex < length) {
    character = unicodeCharAt(str, stringIndex)

    if (unicodeIndex >= start && unicodeIndex < end) {
      accumulator += character
    } else {
      break
    }

    stringIndex += character.length
    unicodeIndex += 1

    // Find the next space offset from the previous finding
    nextSpace = words ? str.indexOf(' ', nextSpace + 1) : -1
    stringIndex = nextSpace > 0 ? nextSpace + 1 : stringIndex
  }

  return accumulator
}

export function getInitialAvatarSrcByProps(props) {
  const ownProps = {
    name: 'Name',
    color: null,
    seed: 0,
    charCount: 1,
    textColor: '#ffffff',
    height: 100,
    width: 100,
    fontSize: 60,
    fontWeight: 400,
    fontFamily:
      'HelveticaNeue-Light, Helvetica Neue Light, Helvetica Neue, Helvetica, Arial, Lucida Grande, sans-serif',
    radius: 0,
    ...props,
  }

  const {
    width,
    height,
    textColor,
    fontFamily,
    fontSize,
    fontWeight,
    charCount,
    useWords,
    name,
    color,
    seed,
    radius: borderRadius,
  } = ownProps

  let initial = unicodeSlice(name || 'Name', 0, charCount || 1, useWords || false).toUpperCase()
  let backgroundColor =
    color !== null ? color : colors[Math.floor((initial.charCodeAt(0) + seed) % colors.length)]

  if (name.length === 0) {
    initial = ''
    ;[backgroundColor] = colors
  }

  const InitialSvg = () => (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      pointerEvents="none"
      {...{
        width,
        height,
        style: {
          width,
          height,
          backgroundColor,
          borderRadius,
        },
      }}
    >
      <text
        y="50%"
        x="50%"
        dy="0.35em"
        pointerEvents="auto"
        fill={textColor}
        fontFamily={fontFamily}
        textAnchor="middle"
        style={{ fontSize, fontWeight }}
      >
        {initial}
      </text>
    </svg>
  )

  const encodedStr = encodeURIComponent(renderToStaticMarkup(<InitialSvg />)).replace(
    /%([0-9A-F]{2})/g,
    (match, p1) => {
      return String.fromCharCode(`0x${p1}`)
    },
  )

  const imgStr = window.btoa(encodedStr)
  // const imgStr = window.btoa(unescape(encodeURIComponent(renderToStaticMarkup(<InitialSvg />))));
  const svgHtml = `data:image/svg+xml;base64,${imgStr}`

  return svgHtml
}

export function getInitialAvatarSrc(name, email, props) {
  if (name == null && email == null) {
    return null
  }

  const avatarProps = {
    ...props,
    // charCount: 2,
    charCount: 1,
  }

  let tmp = []
  if (name != null) {
    tmp = name.split(/[\s\r\n,.]+/gm)
  } else {
    const pos = email.indexOf('@')
    tmp = email.substring(0, pos - 1).split(/[\s\r\n,.]+/gm)
    // const eText = email.substring(pos);
  }

  let str = ''
  tmp.forEach((txt) => {
    if (/^(\p{L}|\d)/gu.test(txt) === true) {
      str += txt.charAt(0)
    }
  })

  avatarProps.name = str

  return getInitialAvatarSrcByProps(avatarProps)
}

export function getTotalPeopleElem(count) {
  const totalStr =
    count === 1
      ? i18n.t('common.total.one', { count: `<span class='count'>${count}</span>` })
      : i18n.t('common.total.more', { count: `<span class='count'>${count}</span>` })

  const totalElem = parse(`<span class='total'>${totalStr}</span>`)
  return totalElem
}

export function getTotalUnitElem(count) {
  const totalStr =
    count === 1
      ? i18n.t('common.totalunit.one', { count: `<span class='count'>${count}</span>` })
      : i18n.t('common.totalunit.more', { count: `<span class='count'>${count}</span>` })

  const totalElem = parse(`<span class='total'>${totalStr}</span>`)
  return totalElem
}

export function getTotalAccountElem(count) {
  const totalStr =
    count === 1
      ? i18n.t('common.totalaccount.one', { count: `<span class='count'>${count}</span>` })
      : i18n.t('common.totalaccount.more', { count: `<span class='count'>${count}</span>` })

  const totalElem = parse(`<span class='total'>${totalStr}</span>`)
  return totalElem
}

export function getEmailName(email) {
  const pos = email.indexOf('@')
  return email.substring(0, pos)
}

function PaginationInfo(options) {
  const { name, offset, limit, searchItems, useSort, onPaginationChange } = options
  const self = this

  self.name = name
  self.offset = offset
  self.limit = limit
  self.total = 0
  self.order = null
  self.dir = null

  self.extParams = {}

  self.searchItems = searchItems
  self.searchFilters = {}
  self.sorts = {}

  self.useSort = useSort === true

  self.mount = () => {
    const params = getSearchParamProps()

    let num = 1

    if (params != null) {
      const { page, nsearch, nsort } = params
      if (page != null) {
        num = page
      }

      let extParams = {}
      if (nsearch != null) {
        self.searchFilters = {}
        Object.entries(nsearch).forEach(([key, value]) => {
          self.searchFilters[key] = value
        })

        extParams = {
          ...extParams,
          ...self.searchFilters,
        }
      }

      if (self.useSort === true) {
        self.sorts = {}
        if (nsort != null) {
          Object.entries(nsort).forEach(([key, value]) => {
            self.sorts.order = key
            self.sorts.dir = value === true ? 'asc' : 'desc'
          })
        }

        // if (self.sorts.order == null && defaultSort != null) {
        //   Object.entries(defaultSort).forEach(([key, value]) => {
        //     self.sorts.order = key
        //     self.sorts.dir = value === true ? 'asc' : 'desc'
        //   })
        // }

        extParams = {
          ...extParams,
          ...self.sorts,
        }
      }

      this.setExtParams(extParams)

      if (self.searchFormObj != null) {
        self.searchFormObj.checkParams()
      }
    }

    self.setPage(num, false, false)
  }

  self.checkParams = () => {
    const params = getSearchParamProps()

    let num = 1

    if (params != null) {
      const { page, nsearch, nsort } = params
      if (page != null) {
        num = page
      }

      let extParams = {}
      if (nsearch != null) {
        self.searchFilters = {}
        Object.entries(nsearch).forEach(([key, value]) => {
          self.searchFilters[key] = value
        })

        extParams = {
          ...extParams,
          ...self.searchFilters,
        }
      }

      if (self.useSort === true && nsort != null) {
        self.sorts = {}
        Object.entries(nsort).forEach(([key, value]) => {
          self.sorts.order = key
          self.sorts.dir = value === true ? 'asc' : 'desc'
        })

        extParams = {
          ...extParams,
          ...self.sorts,
        }
      }

      this.setExtParams(extParams)
    }

    self.setPage(num, false, false)
  }

  self.setExtParams = (params) => {
    self.extParams = params
  }

  self.getReqParam = () => {
    return {
      offset: self.offset,
      limit: self.limit,
      ...self.extParams,
    }
  }

  self.applyRes = (resPagination) => {
    self.offset = resPagination.offset
    self.limit = resPagination.limit
    self.total = resPagination.total
  }

  self.getPagination = () => {
    const current = Math.floor(self.offset / self.limit) + 1
    const ret = {
      current,
      pageSize: self.limit,
      total: self.total,
    }

    if (self.useSort !== true) {
      ret.onChange = (page, pageSize) => {
        self.limit = pageSize
        self.setPage(page, true, true)
      }
    }

    return ret
  }

  self.getOnChange = () => {
    return (pagination, filters, sorter, extra) => {
      if (self.useSort !== true) {
        return
      }

      let curPage = 1
      if (pagination != null) {
        const { current, pageSize } = pagination
        curPage = current != null ? current : 1
        self.limit = pageSize
      }

      if (extra.action === 'sort') {
        const { field, order } = sorter
        console.log('sorter - ', sorter)
        const sort = {}
        const sortMap = {}
        if (order === 'ascend' || order === 'descend') {
          ;[sort.order] = field
          sort.dir = order === 'ascend' ? 'asc' : 'desc'
          sortMap[sort.order] = order === 'ascend'
        } else {
          delete self.extParams.order
          delete self.extParams.dir
        }

        const sortStr = encodeSortMap(sortMap)

        const param = {
          nsort: encodeURIComponent(sortStr),
        }

        if (param.nsort.length === 0) {
          param.nsort = undefined
        }

        setSearchParams(param)

        this.setExtParams({
          ...self.extParams,
          ...sort,
        })
      } else {
        self.setPage(curPage, false, true)
      }
    }
  }

  self.getColumns = (columns) => {
    if (self.useSort !== true) {
      return columns
    }

    const newColumns = []
    columns.forEach((col) => {
      const { dataIndex } = col

      const [order] = dataIndex
      let sortOrder = null
      if (self.extParams.order === order) {
        sortOrder = self.extParams.dir === 'desc' ? 'descend' : 'ascend'
      }

      const newCol = {
        ...col,
      }

      if (col.sorter !== false) {
        newCol.sorter = true
        newCol.sortOrder = sortOrder
      }

      newColumns.push(newCol)
    })

    return newColumns
  }

  self.setPage = (page, skipRefetch, useSearchParam) => {
    let num = page || 1
    if (typeof page === 'string') {
      try {
        num = parseInt(page, 10)
      } catch {
        num = 1
      }
    }
    self.offset = (num - 1) * self.limit

    if (onPaginationChange != null) {
      if (useSearchParam !== false) {
        const params = {}
        if (page > 1) {
          params[self.name] = page
        } else {
          params[self.name] = undefined
        }

        setSearchParams(params)
      }

      if (skipRefetch !== true) {
        onPaginationChange(page, self.limit, self)
      }
    }
  }

  // for searchForm
  self.getSearchItems = () => {
    return self.searchItems
  }

  // for searchForm
  self.getSearchFilters = () => {
    return self.searchFilters
  }

  self.resetSearch = (/* skipRefetch, extItem */) => {
    Object.keys(self.searchFilters).forEach((key) => {
      if (self.extParams[key] != null) {
        delete self.extParams[key]
      }
    })
    self.searchFilters = {}
  }

  self.checkPageReplace = (props, prevProps) => {
    if (props.location != null && prevProps.location != null) {
      if (checkPageReplace(props.location, prevProps.location) === false) {
        console.log(' ----  checkPageReplace ', props, prevProps)
        self.checkParams()
      }
    }
  }

  // for searchForm
  self.search = (key, value, preset, skipRefetch, useSearchParam) => {
    console.log('search - ', key, value, preset, skipRefetch, useSearchParam)

    self.searchFilters = {}

    const params = {
      nsearch: undefined,
    }

    if (value != null) {
      self.searchFilters[key] = undefined

      if (value.trim().length > 0) {
        self.searchFilters[key] = value
        params.nsearch = encodeURIComponent(encodeNSearch(self.searchFilters))
      }
    }

    const extParams = {
      ...self.extParams,
      ...self.searchFilters,
    }

    self.setExtParams(extParams)

    if (useSearchParam === true) {
      setSearchParams(params)
    }

    console.log('onSearch2 - ', key, value)

    // if (skipRefetch !== true) {
    self.setPage(1, skipRefetch, useSearchParam)
    // }

    return true
  }
}

export function createPaginationInfo(offset, limit, onPaginationChange) {
  return new PaginationInfo(offset, limit, onPaginationChange)
}

export function sortIconFunc({ sortOrder }) {
  if (sortOrder != null && (sortOrder === 'ascend' || sortOrder === 'descend')) {
    const icon =
      sortOrder === 'ascend' ? (
        <img src={sortAscendSVG} alt="ascend" />
      ) : (
        <img src={sortDescendSVG} alt="descend" />
      )
    return icon
  }

  return null
}

export function timeFormat(timeStr, formatStr) {
  const format = formatStr || 'YYYY.MM.DD HH:mm'
  return timeFormatOrigin(timeStr, format)
}

export function confirmBase(options) {
  const opts = {
    wrapClassName: options.wrapClassName || classNames('om-popup-1'),
    title: options.title,
    icon: options.icon || null,
    closable: options.closable,
    keyboard: options.maskClosable != null ? options.maskClosable : true,
    maskClosable: options.maskClosable != null ? options.maskClosable : true,
    style: { minWidth: '380px' },
    width: options.width,
    okButtonProps: {
      className: classNames('type1', 'h38'),
      style: { minWidth: '100px' },
      disabled: options.okButtonDisabled,
    },
    cancelButtonProps: {
      className: classNames('h38'),
      style: { minWidth: '100px' },
    },
    content: options.content,
    okText: options.okText || i18n.t('common.button.ok'),
    cancelText: options.cancelText || i18n.t('common.button.cancel'),
    maskTransitionName: 'maskTransitionName',
    onOk: options.onOk,
    onCancel: options.onCancel,
    footer: options.footer,
    closeIcon: options.closeIcon,
    onOpen: options.onOpen,
    open: options.open,
  }

  if (options.hasIcon === true) {
    opts.icon = <img src={xCircleBlue22SVG} alt="noti" />
  }

  return Modal.confirm(opts)
}

export function errorBase(options) {
  const opts = {
    wrapClassName: options.wrapClassName || classNames('om-popup-error-1'),
    title: options.title,
    closable: options.closable,
    keyboard: options.maskClosable != null ? options.maskClosable : true,
    maskClosable: options.maskClosable != null ? options.maskClosable : true,
    style: { minWidth: '380px' },
    width: options.width,
    content: options.content,
    okText: options.okText || i18n.t('common.button.ok'),
    okButtonProps: options.okButtonProps || { className: classNames('h38', 'type1', 'w100') },
    maskTransitionName: 'maskTransitionName',
    onOk: options.onOk,
    footer: options.footer,
  }

  if (options.icon !== undefined) {
    opts.icon = options.icon
  } else {
    opts.icon = <img src={xCircleRed22SVG} alt="error" />
  }

  return Modal.error(opts)
}

export function confirmDelete(options) {
  confirmBase({
    maskTransitionName: options.maskTransitionName || 'maskTransitionName',
    okText: i18n.t('common.button.delete'),
    width: 480,
    okButtonProps: {
      className: classNames('delete', 'h38'),
      style: { minWidth: '100px' },
    },
    cancelButtonProps: {
      className: classNames('h38'),
      style: { minWidth: '100px' },
    },
    icon: <img src={exclamationCircleRed22SVG} alt="delete" />,
    ...options,
  })
}

export function mailApiError(ex) {
  const e = ex.origin != null ? ex.origin : ex
  if (e.message != null) {
    const { code, message, details, desc } = e
    const title = code != null ? i18n.t('common.title.warning') : message
    let content = ''
    if (details != null && details.reason != null) {
      if (details.reason.includes('Max domain quota reached')) {
        content = i18n.t('error.maxDomainQuota')
      } else if (details.reason.includes("too long for the column's type")) {
        content = i18n.t('error.maxQuota')
      } else {
        content = details.reason
      }
    } else if (desc != null) {
      content = details.desc
    } else if (details != null && details['param.local_part'] != null) {
      if (details['param.local_part'].message?.includes('should be less than or equal to 64')) {
        content = i18n.t('error.tooLongEmail')
      }
    }

    errorBase({
      title,
      content,
      width: 450,
    })
  } else {
    errorBase({
      title: 'Unknown error',
      content: JSON.stringify(e),
      width: 450,
    })
  }
}

export function popupDoc(options) {
  return confirmBase({
    wrapClassName: classNames(styles.docPopup),
    maskTransitionName: 'maskTransitionName',
    closable: true,
    footer: null,
    width: 896,
    ...options,
  })
}

export function openPrivacy(e) {
  popupDoc({
    title: '개인 정보 처리 방침',
    content: (
      <div className={classNames(styles.docScroll)}>
        <iframe
          id="contentFrame"
          title="OfficeMail Privacy Policy"
          src="/static/OfficeMail_privacy_policy_20250325.htm?code=1"
          marginWidth="0"
          marginHeight="0"
          frameBorder="0"
          width="100%"
          height="100%"
          scrolling="yes"
        />
      </div>
    ),
  })

  if (e != null) {
    e.stopPropagation()
    e.preventDefault()
  }
}

export function openTerms(e) {
  popupDoc({
    title: '이용 약관',
    content: (
      <div className={classNames(styles.docScroll)}>
        <iframe
          id="contentFrame"
          title="OfficeMail Privacy Policy"
          src="/static/OfficeMail_terms_use_20250325.htm?code=1"
          marginWidth="0"
          marginHeight="0"
          frameBorder="0"
          width="100%"
          height="100%"
          scrolling="yes"
        />
      </div>
    ),
  })

  if (e != null) {
    e.stopPropagation()
    e.preventDefault()
  }
}

export function logout() {
  // confirmBase({
  //   maskTransitionName: 'maskTransitionName',
  //   okButtonProps: {
  //     className: classNames('type1', 'h38'),
  //     style: {minWidth: '100px'}
  //   },
  //   cancelButtonProps: {
  //     className: classNames('h38'),
  //     style: {minWidth: '100px'}
  //   },
  //   okText: i18n.t('logOut.button.logout'),
  //   title: i18n.t('logOut.title.logout'),
  //   content: i18n.t('logOut.desc.logout'),
  //   onOk: () => {
  //     logoutOfficeNEXT();

  //     reduxStore.dispatch({
  //       type: 'user/LOGOUT',
  //     });
  //   },
  //   width: 480,
  // });

  logoutOfficeNEXT()

  reduxStore.dispatch({
    type: 'user/LOGOUT',
  })
}

export function getOfficeNEXTURL(path) {
  const { officeNextURL } = conf

  if (officeNextURL != null && officeNextURL.length > 0) {
    const lang = i18n.language.substring(0, 2)
    const pathStr = path || '/'
    return `${officeNextURL}/${lang}${pathStr}`
  }

  return null
}

export function logoutOfficeNEXT() {
  const officenext = store.get('app.user.officenext')
  if (officenext == null) {
    return
  }

  confirmBase({
    maskTransitionName: 'maskTransitionName',
    okButtonProps: {
      className: classNames('type1', 'h38'),
      style: { minWidth: '100px' },
    },
    cancelButtonProps: {
      className: classNames('h38'),
      style: { minWidth: '100px' },
    },
    title: i18n.t('logOut.title.officeNext'),
    content: i18n.t('logOut.desc.officeNext'),
    onOk: () => {
      const logoutURL = getOfficeNEXTURL('/logout')
      if (logoutURL != null && logoutURL.length > 0) {
        // window.location.href = logoutURL;
        window.open(logoutURL)

        // const windowSize = {
        //   width: 930,
        //   height: 775,
        // }
        // const windowLocation = {
        //   left: window.screen.availLeft + window.screen.availWidth / 2 - windowSize.width / 2,
        //   top: window.screen.availTop + window.screen.availHeight / 2 - windowSize.height / 2,
        // }

        // const options = `width=${windowSize.width},height=${windowSize.height},left=${windowLocation.left},top=${windowLocation.top}`

        // window.open(logoutURL, "logout", options);
      }
    },
  })
}

export function getTechSupportElem() {
  return (
    <div>
      {i18n.t('onboarding.selectDomain.techSupport')} | 1661-5975, &nbsp;
      <a href="mailto:officetech@jiran.com" target="_blank" rel="noreferrer">
        officetech@jiran.com
      </a>
    </div>
  )
}

export function openloadingAni(options) {
  const opts = {
    wrapClassName: classNames('loading-ani-popup'),
    maskTransitionName: 'maskTransitionName',
    icon: null,
    width: 384,
    title: null,
    footer: null,
    content: (
      <div className={classNames('loading-content')}>
        <div className={classNames('loading-ani')}>
          <img src={syncAniGIF} alt="sync" />
        </div>
        <div className={classNames('loading-text')}>{options.text}</div>
      </div>
    ),
  }

  return Modal.confirm(opts)
}

const uiUtil = {
  getInitialAvatar,
  getInitialAvatarSrcByProps,
  getInitialAvatarSrc,
  getTotalPeopleElem,
  getTotalUnitElem,
  getEmailName,
  createPaginationInfo,
  sortIconFunc,
  timeFormat,
  confirmDelete,
  openPrivacy,
  openTerms,
  getOfficeNEXTURL,
  logoutOfficeNEXT,
  getTechSupportElem,
}

export default uiUtil
